import React from 'react';

import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';

export interface TablePagerProps {
  page: number;
  setPage: (page: number | ((p: number) => number)) => void;
  total: number;
  rowsPerPage: number;
}

export const TablePager = ({
  page,
  setPage,
  total,
  rowsPerPage,
}: TablePagerProps) => {
  if (total <= rowsPerPage) return null;
  const lastPage = Math.ceil(total / rowsPerPage) - 1;
  const from = page * rowsPerPage + 1;
  const to = Math.min((page + 1) * rowsPerPage, total);
  return (
    <Box display="flex" justifyContent="center" alignItems="center" py={1}>
      <IconButton
        aria-label="First page"
        size="small"
        disabled={page === 0}
        onClick={() => setPage(0)}
      >
        <FirstPageIcon fontSize="small" />
      </IconButton>
      <IconButton
        aria-label="Previous page"
        size="small"
        disabled={page === 0}
        onClick={() => setPage(p => p - 1)}
      >
        <ChevronLeftIcon fontSize="small" />
      </IconButton>
      <Typography
        variant="body2"
        color="textSecondary"
        style={{ margin: '0 8px' }}
      >
        {from}-{to} of {total}
      </Typography>
      <IconButton
        aria-label="Next page"
        size="small"
        disabled={page >= lastPage}
        onClick={() => setPage(p => p + 1)}
      >
        <ChevronRightIcon fontSize="small" />
      </IconButton>
      <IconButton
        aria-label="Last page"
        size="small"
        disabled={page >= lastPage}
        onClick={() => setPage(lastPage)}
      >
        <LastPageIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};
